module.exports = __webpack_public_path__ + "static/Sally-ec84f29019a50d2429e73987b708ec65.png";